import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, RetriggerWebhookResponseDialogueHandler } from './types';
import WebhookContext from './RetriggerWebhookResponseContext';

const { ConfirmationDialogue } = vp;

type WebhookDialogueProps = {
  handleDialogue: DialogueHandler<RetriggerWebhookResponseDialogueHandler>;
};

type FC = FunctionComponent<WebhookDialogueProps>;

const RetriggerWebhookResponseDialogue: FC = ({ handleDialogue }: WebhookDialogueProps) => {
  const { showRetriggerWebhookErrorAlert, retriggerError, showRetriggerSuccessAlert } = useContext(WebhookContext);

  const ErrorMessage = retriggerError !== '' ? retriggerError : 'Try again in a few seconds';
  return useMemo(
    () => (
      <div>
        {/* Retrigger error*/}
        <ConfirmationDialogue
          isVisible={showRetriggerWebhookErrorAlert}
          title="Webhook unable to be retriggered."
          status="error"
          subTitle={`${ErrorMessage}`}
          confirm={{
            label: 'Back to Webhook',
            action: () => handleDialogue({ type: 'error', state: 'error' }),
          }}
        />

        {/* Retrigger Success */}
        <ConfirmationDialogue
          isVisible={showRetriggerSuccessAlert}
          title="Success! The webhook successfully retriggered."
          status="success"
          subTitle="Navigate back to your users."
          confirm={{
            label: 'Back to Webhook',
            action: () => handleDialogue({ type: 'alert', state: 'success' }),
          }}
        />
      </div>
    ),
    [showRetriggerWebhookErrorAlert, showRetriggerSuccessAlert],
  );
};

export default RetriggerWebhookResponseDialogue;
